import { Text } from "@mantine/core";
import { isNumber } from "@tiptap/react";
import {
  rStatusList,
  summaryStatusList,
} from "../../../../../../../pages/Summary/Summary.utils";
import useNonMaritime from "../../../../../../../hooks/useNonMaritime";
import { isUnverifiedStatus } from "src/utils/entryStatus";
interface Props {
  size?: string | number;
  status: number;
  rStatus: number | undefined;
  autosave?: number;
}
const ReviewStatus = ({ size, status, rStatus, autosave }: Props) => {
  const { replaceMaritimeText } = useNonMaritime();
  const isAudit = window.location.toString().includes("audits/audit");
  const isReview = window.location.toString().includes("reviews/review");
  if (autosave === 1 && isUnverifiedStatus(status)) {
    return (
      <Text
        fz={size}
        c={summaryStatusList[status].color}
        fw={summaryStatusList[status].fontWeight}>
        {`${summaryStatusList[status].status} / Auto Save`}
      </Text>
    );
  } else {
    if (isNumber(rStatus)) {
      if (rStatus === 0) {
        let label = rStatusList[rStatus].status;
        if (isAudit) label += " Audit";
        else if (isReview) label += " Review";
        return (
          <Text
            fz={size}
            c={rStatusList[rStatus].color}
            fw={rStatusList[rStatus].fontWeight}>
            {label}
          </Text>
        );
      }
      return (
        <Text
          fz={size}
          c={rStatusList[rStatus].color}
          fw={rStatusList[rStatus].fontWeight}>
          {rStatusList[rStatus].status}
        </Text>
      );
    } else {
      return (
        <Text
          fz={size}
          c={summaryStatusList[status]?.color ?? ""}
          fw={summaryStatusList[status]?.fontWeight ?? ""}>
          {replaceMaritimeText(summaryStatusList[status]?.status ?? "")}
        </Text>
      );
    }
  }
};
export default ReviewStatus;
